import React from 'react';
import { useRoutes } from 'react-router';
import { publicRoutes } from './public';

export const AppRoutes: React.FC = () => {
  const routes = useRoutes(publicRoutes);
  
  return <>{routes}</>;
};
